import styled, {css} from "styled-components";
import GearSvg from "../../../assets/images/m_cnt4_gear.svg";
import DialogSvg from "../../../assets/images/m_cnt4_dialog.svg";

export const Container = styled.div`
  height: 4000px;
  color: ${({theme}) => theme.colors.black};
  margin-top: 20vh;
  margin-bottom: 10vh;
  display: none;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: block;
  }
`

export const Content = styled.div`
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  height: 100%;
`

export const Notebook = styled.img`
  width: auto;
  height: 80vh;
  position: sticky;
  margin-left: 50px;
  top: 15vh;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    margin-left: 300px;
  }
`

const Line = styled.div`
  position: relative;
  width: 90%;
  margin-left: 10%;
  height: 250px;
  opacity: 0.9;
  border-radius: 40px 0 0 40px;
  ${({theme}) => css`border: 1px solid ${theme.colors.cardBorderColor}`};
  background: ${({theme}) => theme.colors.secondaryBackground};
`

export const Text = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: auto;
  height: 100%;
  width: 70%;
  float: left;
  position: relative;
  color: ${({theme}) => theme.colors.primaryFont};
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 40px;

  & span {
    margin-left: 10%;
  }
`

export const Line1 = styled(Line)`
  top: 500px;

  &::after {
    display: block;
    content: " ";
    background-image: url('${GearSvg}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 100%;
    position: absolute;
    width: 120px;
    left: 60%;
    top: 150px;
  }
`

export const Line2 = styled(Line)`
  top: 1000px;
  height: 200px;
`

export const Line3 = styled(Line)`
  top: 1500px;
  height: 150px;

  &::after {
    display: block;
    content: " ";
    background-image: url('${DialogSvg}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 100%;
    position: absolute;
    width: 200px;
    left: 40%;
    top: 100px;
  }
`

export const Line4 = styled(Line)`
  top: 2000px;
  height: 200px;
`

export const Line5 = styled(Line)`
  top: 2500px;
  height: 200px;
`